import { push } from "react-router-redux";
import api from "APP_ROOT/api";
import { SUCCESS } from "LIB/submission";
import { PORTAL_PURCHASE } from "MODULES/PurchaseOrders/constants";
import * as actionTypes from "../actionTypes";
import { companiesPagination } from "../pagination";

export const { search, setFilter } = companiesPagination;
export * from "./aircrafts/actions";
export * from "./contacts/actions";
export * from "./PhysicalAddresses/actions";
export * from "./RelatedCompanies/actions";
export * from "./ShippingMethods/actions";

export function show(id) {
  return dispatch =>
    api.companies.show(id).then(resp =>
      dispatch({
        type: actionTypes.SET,
        company: resp.data
      })
    );
}

export function update(data) {
  return (dispatch, getState) => {
    const companyId = getState().companyDetail.getIn(["company", "id"]);

    return api.companies.update(companyId, data).then(resp => {
      dispatch({
        type: actionTypes.SET,
        company: resp.data
      });
      return SUCCESS;
    });
  };
}

export function create(data) {
  return dispatch =>
    api.companies.create(data).then(resp => {
      dispatch({
        type: actionTypes.SET,
        company: resp.data
      });
      dispatch(push(`/companies/${resp.data.id}`));
    });
}

export function validateContact(
  { contact = {}, contact_id: contactId = null },
  _action,
  _props
) {
  const { email } = contact;
  if (
    !email ||
    email.includes("+demo") ||
    (["Add", PORTAL_PURCHASE].includes(contactId) && contactId)
  ) {
    return Promise.resolve();
  }

  return api.contacts.list({ email }).then(resp => {
    if (resp.data.total_count > 0) {
      const errors = {
        contact: {
          email: ["Already taken"]
        }
      };

      return Promise.reject(errors);
    }
    return null;
  });
}

export function searchRepairStationCompanies() {
  return name => () =>
    api.companies
      .search({
        cached: true,
        filter: name,
        status: "active,credit_hold,do_not_do_business",
        type: "simple",
        limit: 20
      })
      .then(resp => resp.data.results);
}

export function searchCompanies(filter) {
  return () =>
    api.companies
      .search({
        filter,
        sort: "name",
        reverse: false,
        page: 1,
        limit: 20
      })
      .then(resp => Promise.resolve(resp.data.results));
}



// WEBPACK FOOTER //
// ./app/modules/companies/actions/actions.js